export default __webpack_public_path__ + "static/Nurse-practitioner-7d9b8e9e65b72de2a328a10b63be39f3.webp";